<div class="chart_style">
        <canvas
            baseChart
            [datasets]="chartData"
            [labels]="dateFormatLabels"
            [options]="lineChartOptions"
            [type]="chartType"
            (chartHover)="chartHovered($event)"
            (chartClick)="chartClicked($event)"></canvas>
</div>
<!-- [colors]="colorArray" -->
